import script from "./Page.vue?vue&type=script&setup=true&lang=js"
export * from "./Page.vue?vue&type=script&setup=true&lang=js"

import "./Page.vue?vue&type=style&index=0&id=185b532a&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-185b532a"]])

export default __exports__